var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorization p-5"},[_c('div',{staticClass:"btn btn-secondary",on:{"click":_vm.switchType}},[_vm._v("Switch")]),(_vm.type == 'Login')?_c('LoginForm'):_c('RegisterForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }